import React from "react";
import "./CustomDeleteModal.scss";
import { WarningIcon } from "../../../icons";
import {
  CancelBtn,
  DeleteBtn,
  deleteForcasteInfo,
  removeForecast,
} from "../../../util/constants";
import { Button } from "../../CommonUIComponents/Button/Button";
import { Modal } from "../../CommonUIComponents/Modal/Modal";

export function AddForecastCustomDelete({
  isModalVisible,
  onClose,
  onDelete,
  data,
}) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={
        <div className="file-version-history-modal-header">
          <div className="motif-fab">
            <WarningIcon />
          </div>
          <span>{removeForecast}</span>
        </div>
      }
      body={
        <>
          <span>{deleteForcasteInfo}</span>
        </>
      }
      className={"add-forecast-delete-modal"}
      footer={
        <div className="custom-delete-footer">
          <Button variant="secondary" onClick={onClose}>
            {CancelBtn}
          </Button>
          <Button variant="primary" onClick={onDelete}>
            {DeleteBtn}
          </Button>
        </div>
      }
    />
  );
}
